import { AfterViewInit, Component, ElementRef, inject, input, OnDestroy } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss'
})
export class SvgIconComponent implements AfterViewInit, OnDestroy {

  name = input<string>('')
  width = input<number>()
  height = input<number>()

  private element = inject<ElementRef<HTMLElement>>(ElementRef)

  private obs = combineLatest([
    toObservable(this.name),
    toObservable(this.width),
    toObservable(this.height),
  ])

  private sb?: Subscription

  ngOnDestroy(): void {
    this.sb?.unsubscribe()
  }

  ngAfterViewInit(): void {
    this.sb = this.obs.subscribe(([, width, height]) => {
      const svg = this.element.nativeElement.querySelector('svg')
      if (svg) {
        svg.style.width = width ? `${width}px` : ''
        svg.style.height = height ? `${height}px` : ''
      }
    })
  }
}
